import {UrlService} from '../services/url-service';
import {GATracker} from './b2c-ga-tracker-service';

export class HeroSeaMove {
    /*
     We need certain values assigned on hero form in the wizard flow to preselect them for use.
     to include additional properties and preselect them on wizard form just add its name to the list.
     */
    static readonly SIGNIFICANT_URL_PARAMS = [
        'postcode', // to prefill postal code when user entered it either on SEO or SEA Hero Forms
        'type', // to preselect type when user came from SEO where default type was selected or from International SEA page
        'to_country', // to preselect country when user came from International SEA page where he selected country of destination
        'to_region', // the same as 'to_country' for AU, DK and SE
        'postcode_typeahead', // to preselect postcode_typeahead for AU and AR
        'suburb_typeahead', // to preselect suburb_typeahead for ZA
        'from_city', // to preselect from_city for AU, ZA and AR
        'from_administrative_area', // to preselect from_administrative_area for AU
        'from_dependent_locality', // to preselect from_dependent_locality for AU
        'location_emirate', // to preselect location_emirate for AE
        'location_county' // to preselect location_county for IE
    ]

    public openWizard(event: Event, htmlFormElement: HTMLFormElement, url: string): void {

        GATracker.sendFormStartEvent();

        // We need to prevent default form submit to avoid page reload
        event.preventDefault();

        const data = this.getFormData(htmlFormElement);

        const queryParams = this.getQueryParams(window.location.href);

        const significantQueryParams = this.getSignificantQueryParams(queryParams);

        const queryPayload = {...data, ...significantQueryParams};

        if(Object.keys(queryPayload).length > 0) {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const {to_country_typeahead, to_region_typeahead, ...filteredQueryPayload} = queryPayload;
            const searchString = UrlService.serializeObjectToQueryString(filteredQueryPayload);
            url = `${url}?${searchString}`;
        }

        window.open(url, '_self');
    }

    private getFormData(htmlFormElement: HTMLFormElement): Record<string, FormDataEntryValue> {
        const formData = new FormData(htmlFormElement);
        let data = {};
        formData.forEach((value, key) => {
            if (value) {
                data[key] = value;
            }
        });
        return data;
    }

    private getQueryParams(url: string): Record<string, string> {
        const searchParams = new URLSearchParams(new URL(url).search);
        const queryParams: Record<string, string> = {};

        for (const [key, value] of searchParams.entries()) {
            queryParams[key] = value;
        }

        return queryParams;
    }

    private getSignificantQueryParams(queryParams: Record<string, string>): Record<string, string> {
        const significantQueryParams: Record<string, string> = {};

        for (const key of HeroSeaMove.SIGNIFICANT_URL_PARAMS) {
            if (queryParams[key]) {
                significantQueryParams[key] = queryParams[key];
            }
        }

        return Object.keys(queryParams)
            .filter(key => HeroSeaMove.SIGNIFICANT_URL_PARAMS.includes(key))
            .reduce((obj, key) => {
                obj[key] = queryParams[key];
                return obj;
            }, {});
    }
}

(<any>window).skyComponents = (<any>window).skyComponents || {};
(<any>window).skyComponents.heroSeaMove = new HeroSeaMove();
